import { frontendURL } from '../../../helper/URLHelper';
import AgendaView from './AgendaView.vue';

const AGENDA_PERMISSIONS = ['administrator', 'agent'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/agenda'),
    name: 'agenda_view',
    meta: {
      permissions: AGENDA_PERMISSIONS,
    },
    component: AgendaView,
  },
];
